import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { PosthogService } from 'src/app/services/posthog.service';
import { OverviewProjectService } from 'src/app/services/overview-project.service';
import { AppConfigurationService } from 'src/app/services/app.configuration.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-invest-document-viewfinder',
  templateUrl: './invest-document-viewfinder.component.html',
  styleUrls: ['./invest-document-viewfinder.component.scss'],
})
export class InvestDocumentViewfinderComponent implements OnInit, OnChanges {

  @Output() public prevEvent = new EventEmitter<any>();
  @Output() public goToSignDocuments = new EventEmitter<any>();
  @Input() documents: any;
  @Input() btnList = true;
  @Input() hasBackBtn = true;

  platform: string;

  constructor(
    private cdRef: ChangeDetectorRef,
    private posthogService: PosthogService,
    private overviewService: OverviewProjectService,
    private appConfigurationService: AppConfigurationService
  ) { }

  url: string | undefined;
  zoom = 1;
  currentselected = 0;
  readedByTime = false;
  readedByScroll = false;
  numberOfPages: number;
  currentPage: number;

  ngOnInit() {
    this.loadDocuments();
    setTimeout(() => this.readedByTime = true, 30000);
    // this.posthogService.pushEvent('reading_invest_document');
    this.cdRef.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.documents) {
      this.loadDocuments();
    }
  }

  async loadDocuments() {
    this.currentPage = 1;
    this.url = undefined;
    this.documents = Array.isArray(this.documents) ? this.documents : [];

    await Promise.all(this.documents.map(async (document, i) => {
      // ngOnInit + ngOnChanges llaman ambos a loadDocuments(); sin esta guarda, la segunda vuelta
      // intentaría resolver la url ya resuelta como si fuera de nuevo el endpoint de metadatos.
      if (!document['_resolved']) {
        document['url'] = await this.resolveDocumentUrl(document);
        document['_resolved'] = true;
      }
      document['selected'] = i === 0;
      document['id'] = i;
    }));

    this.url = this.documents[0]?.url;
    this.cdRef.detectChanges();
  }

  private async resolveDocumentUrl(document: any): Promise<string | undefined> {
    const rawUrl = document?.url || document?.file?.url || document?.files?.[0]?.url;
    const rawContent = document?.content || document?.file?.content || document?.files?.[0]?.content;
    const rawFormat = document?.format || document?.file?.format || document?.files?.[0]?.format;

    // Formato antiguo (mientras convivan front/back): rawUrl es un endpoint de metadatos propio que
    // hay que resolver para sacar el enlace real (S3) o el content en base64.
    const isOwnApiUrl = typeof rawUrl === 'string' && rawUrl.startsWith(this.appConfigurationService.get('domain'));
    if (isOwnApiUrl) {
      const resolved = await firstValueFrom(this.overviewService.resolveProjectFile(rawUrl)).catch(() => null);
      if (resolved?.url) { return resolved.url; }
      if (resolved?.content) {
        return `data:${resolved.format || 'application/pdf'};base64,${resolved.content}`;
      }
      return undefined;
    }

    // Formato nuevo: rawUrl ya es el enlace final (S3), o si no, rawContent trae el base64.
    if (rawUrl) { return rawUrl; }
    if (rawContent) { return `data:${rawFormat || 'application/pdf'};base64,${rawContent}`; }
    return undefined;
  }

  selectDocument(id) {
    if (!this.documents || this.documents.length === 0) {
      return;
    }
    for (let i = 0; i < this.documents.length; i++) {
      if (i === id) {
        this.url = this.documents[i].url;
        this.documents[i]['selected'] = true;
      } else {
        this.documents[i]['selected'] = false;
      }
    }
    this.cdRef.detectChanges();
  }

  next() {
    this.goToSignDocuments.emit();
    this.sendPosthogEvent();
    this.cdRef.detectChanges();
  }

  prev() {
    this.prevEvent.emit();
    this.sendPosthogEvent();
    this.cdRef.detectChanges();
  }

  pageChange(value) {
    this.currentPage = value.pageNumber;
    if (value.pageNumber > 6) {
      this.readedByScroll = true;
    }
    this.cdRef.detectChanges();
  }

  sendPosthogEvent() {
    if (this.readedByTime && this.readedByScroll) {
      // Ha leido los documentos
      // this.posthogService.pushEvent('finish_readed_invest_document');
    } else {
      // No ha leido los documentos
      // this.posthogService.pushEvent('finish_no_readed_invest_document');
    }
    this.cdRef.detectChanges();
  }

  getNumberOfPages(pages) {
    this.numberOfPages = pages;
    this.cdRef.detectChanges();
  }

}
